import { render, staticRenderFns } from "./SamOrderDetail.vue?vue&type=template&id=d19058d6&scoped=true"
import script from "./SamOrderDetail.vue?vue&type=script&lang=js"
export * from "./SamOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./SamOrderDetail.vue?vue&type=style&index=0&id=d19058d6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19058d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d19058d6')) {
      api.createRecord('d19058d6', component.options)
    } else {
      api.reload('d19058d6', component.options)
    }
    module.hot.accept("./SamOrderDetail.vue?vue&type=template&id=d19058d6&scoped=true", function () {
      api.rerender('d19058d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/samOrderList/components/SamOrderDetail.vue"
export default component.exports